// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Ice Ram",
  id: "ice-ram",
  metadata: {
    aspect: SavedSpellAspect.Ice,
    imports: ["ice","vector","air","self"],
    icon: {
      "backgroundColor": 2113879,
      "layers": [
        {
          "iconKey": "iceBolt",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": -1,
          "color": 1105663
        },
        {
          "iconKey": "air",
          "position": {
            "x": 15,
            "y": 2
          },
          "scale": 0.63,
          "rotation": 18,
          "color": 16187391
        }
      ]
    },
  },
};

export default metadata;
